import ColorLegend from "./ColorLegend";
import useMapData from "./useMapData";
import MapContainer from "./MapContainer";
import { useState, useEffect, useRef } from "react";
import { interpolateYlOrRd, scaleQuantile, scaleSqrt, max } from "d3";
import { FormControlUnstyledContext, Slider } from "@mui/material";
import "./Chart.css";
import ChartDataCheck from "./ChartDataCheck";
import fuelColors from "../../ChartConfigFiles/FuelColors.json";
import tagLong from "../../ChartConfigFiles/Tag_long.png";

const Map = ({
  chartRef,
  chartTitle,
  chartSubtitle,
  isLoading,
  data,
  selectedYear,
  setSelectedYear,
  maxValue,
  sliderValue,
  setSliderValue,
  fuel,
  datasetTitle,
}) => {
  const [mapData, rawMapData] = useMapData();

  const coloredDataset = [
    "generation_yearly",
    "capacity_yearly",
    "emissions_yearly",
  ];

  const getFuelColors = () => {
    if (!coloredDataset.includes(datasetTitle)) {
      return ["#FCA311", "#E04B00", "#891B05"];
    }

    const fuelItem = fuelColors.find(
      (fuelItem) => fuelItem.fuel === fuel.value
    );

    return fuelItem ? fuelItem.colors : ["#FED188", "#E04B00", "#891B05"];
  };

  const getMainFuelColor = () => {
    let fuelColors = getFuelColors();
    let mainColor = fuelColors[1];

    return mainColor;
  };

  const colorScale = scaleSqrt(
    [0, Math.pow(maxValue, 0.5), maxValue],
    getFuelColors()
  );

  const sliderStyle = {
    color: getMainFuelColor(),
    ".MuiSlider-valueLabel": {
      fontFamily: "Ember-regular",
      fontSize: "12px",
      fontWeight: "600",
      backgroundColor: "#1d3249",
    },
  };

  const handleSliderChange = (value) => {
    setSliderValue(value);
  };

  return (
    <div className="chart-container">
      <div className="chart-display" ref={chartRef}>
        <img
          alt=""
          className="chart-tag-long"
          id="tag-long"
          src={tagLong}
          style={{ visibility: "visible" }}
        />
        <div className="chart-header">
          <div className="chart-title">{chartTitle + ` (${selectedYear})`}</div>
          <div className="chart-subtitle">{chartSubtitle}</div>
        </div>
        <div className="chart-body">
          <ChartDataCheck isLoading={isLoading} chartData={data}>
            <div className="chart map-chart">
              <MapContainer
                countries={mapData}
                rawMapData={rawMapData}
                data={data}
                colorScale={colorScale}
                maxValue={maxValue}
                setSelectedYear={setSelectedYear}
              />
            </div>
          </ChartDataCheck>
        </div>
        <div className="chart-footer">
          <div className="source-text">
            Source: Ember Electricity Data Explorer, ember-climate.org
          </div>
          <div className="logo-container">
            <img
              alt=""
              className="logo"
              id="logo"
              src="https://public.flourish.studio/uploads/3bd4add8-1f15-49c6-b134-5ecfe0de6a0a.png"
              style={{ visibility: "visible" }}
            />
          </div>
        </div>
      </div>
      <div className="chart-controls">
        <div className="slider-container">
          <div className="slider-label">Year:</div>
          <Slider
            value={sliderValue}
            aria-label="Small steps"
            step={1}
            marks={true}
            min={2000}
            max={2021}
            valueLabelDisplay="on"
            onChange={(_, value) => handleSliderChange(value)}
            onChangeCommitted={(_, value) => setSelectedYear(value)}
            sx={sliderStyle}
          />
        </div>
      </div>
    </div>
  );
};

export default Map;
